export class WagtailConfig {
  formsBaseUrl?: string;
  pagesBaseUrl?: string;
}
